import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {
  Backdrop,
  ButtonBase,
  Box,
  CircularProgress,
  InputBase,
  Grid,
  Typography,
} from '@material-ui/core';

import BoxCenter from '../components/BoxCenter';
import { makeStyles } from '@material-ui/styles';
import Logo from './Logo';
const useStyles = makeStyles((theme) => ({
  backDrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    pointerEvents: 'all',
    zIndex: 2,
  },
  bg: {
    backgroundImage: 'url(images/login/framing_4.png)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 275,
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(4),
    width: 400,
  },
  loginButton: {
    backgroundColor: 'transparent',
    backgroundImage: 'url(images/login/btn_green_L_normal.png)',
    backgroundSize: 'contain',
    border: 'none',
    color: 'white',
    height: 71,
    outline: 'none',
    paddingBottom: 30,
    fontFamily: 'PJ_WangNgan',
    fontSize: 'xx-large',
    width: 120,
    '&:active': {
      paddingBottom: 25,
      backgroundImage: 'url(images/login/btn_green_L_active.png)',
    },
  },
  resetPassword: {
    color: 'white',
    fontFamily: 'PJ_WangNgan',
    fontSize: 'x-large',
    fontStyle: 'italic',
    marginTop: theme.spacing(0.5),
  },
  root: {
    transform: ({ scale }) => `scale(${window.devicePixelRatio * scale})`,
    pointerEvents: 'all',
  },
  textField: {
    backgroundImage: 'url(images/login/framing_3.png)',
    height: 50,
    padding: theme.spacing(1),
    width: 350,
  },
}));
const initialState = {
  username: '',
  password: '',
};
const Login = ({ onSubmit, onReset, scale, loading }, ref) => {
  const {
    backDrop,
    bg,
    loginButton,
    resetPassword,
    root,
    textField,
  } = useStyles({ scale });
  const [form, setForm] = useState(initialState);
  const [errorMessage, setErrorMessage] = useState('');
  useImperativeHandle(ref, () => ({
    setError: (err) => {
      setErrorMessage(err);
    },
  }));
  const handleTextFieldChange = ({ target }) => {
    setForm({ ...form, [target.name]: target.value });
  };
  const handleSubmit = () => {
    if (form.username !== '' && form.password !== '') {
      onSubmit(form);
    }
  };
  const handleResetPassword = () => {
    onReset();
  };
  return (
    <BoxCenter>
      <Box
        width={400}
        height={600}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        className={root}
      >
        <Grid container justify="center" alignItems="flex-start">
          <Grid item>
            <Logo />
          </Grid>
          <Grid item>
            <div className={bg}>
              <Box position="absolute" right={25}>
                <Typography variant="body1" color="error" align="center">
                  {errorMessage}
                </Typography>
              </Box>
              <Box m={1}>
                <Typography variant="h5">รหัสพนักงาน</Typography>
                <InputBase
                  className={textField}
                  value={form.username}
                  name="username"
                  onChange={handleTextFieldChange}
                  placeholder="username"
                />
              </Box>
              <Box m={1}>
                <Typography variant="h5">รหัสผ่าน</Typography>
                <InputBase
                  className={textField}
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleTextFieldChange}
                  placeholder="password"
                  inputProps={{
                    maxLength: 12,
                  }}
                />
              </Box>
            </div>
          </Grid>
          <Grid item>
            <Box display="flex" flexDirection="column">
              <button onClick={handleSubmit} className={loginButton}>
                ล็อกอิน
              </button>
              <ButtonBase
                className={resetPassword}
                onClick={handleResetPassword}
              >
                ลืมรหัสผ่าน
              </ButtonBase>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Backdrop className={backDrop} open={loading}>
        <CircularProgress />
      </Backdrop>
    </BoxCenter>
  );
};
export default forwardRef(Login);
